import { Box, Container, Typography, makeStyles } from "@material-ui/core";

import React from "react";

// import { useDispatch } from "react-redux";
export const ProductCatalog = (props: any) => {
  const classes = useStyles();
  //const dispatch = useDispatch();
  return (
    <Box className={classes.container}>
      <Container className={classes.root}>
        <Typography variant="h5" component="h1" color="textPrimary">
          Product Catalogue
        </Typography>
      </Container>
    </Box>
  );
};
const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "center",
  },
  root: {
    flexGrow: 1,
    maxWidth: "840px",
  },
  content: {
    display: "flex",
    height: "100%",
    paddingLeft: 0,
    paddingRight: 0,
  },
});
